<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-05 16:31:19
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-19 10:53:19
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\components\tableCells\titleCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<template v-if="row.type === 1">
			<p class="yx-color-pure-1 font-h4-regular">集合页</p>
		</template>
		<template v-else>
			<p class="yx-color-pure-1 font-h4-regular" v-for="(item, index) in locationList" :key="index">位置{{ index + 1 }}： {{ item.linkTypeDesc }}</p>
		</template>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	computed: {
		locationList({ row }) {
			const { locationList = [] } = row;
			const list = JSON.parse(JSON.stringify(locationList));
			list.splice(0, 1);
			return list;
		},
	},
	data() {
		return {};
	},
};
</script>
<style lang="less" scoped></style>
